























import Vue from 'vue'
import PageTitle from '@/components/atoms/PageTitle.vue'
import ReloadItem from '@/components/molecules/ReloadItem.vue'
import CheckInItem from '@/components/molecules/CheckInItem.vue'
import { State as StampsState } from '@/store/modules/stamps'

export default Vue.extend({
  name: 'CheckIn',
  components: {
    PageTitle,
    ReloadItem,
    CheckInItem
  },
  computed: {
    stamps(): StampsState['stamps'] {
      const now = new Date().getTime()
      return this.$state.stamps.stamps.filter(s => Date.parse(s.release_time) <= now && now <= Date.parse(s.expiration_time))
    }
  },
  methods: {
    async success(position: any) {
      await this.$store.dispatch('stamps/fetchCheckInStamps', {
        latitude: position.coords.latitude,
        longitude: position.coords.longitude
      })
    },
    error() {
      this.$store.dispatch(
        'flash/setMessage',
        {
          message: '位置情報の取得に失敗しました',
          isAlert: true
        },
        {
          root: true
        }
      )
    },
    reloadFunc() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(this.success, this.error, {
          enableHighAccuracy: true,
          timeout: 5000,
          maximumAge: 0
        })
      }
    },
    async handleCheckIn(params: { stamp_id: string }) {
      await this.$store.dispatch('stamps/postCheckIn', { ...params, location: this.$state.stamps.currentLocation })
    },
    formatDistance(d: number): string {
      if (d < 1) {
        return Math.floor(d * 1000) + 'm'
      }
      return Math.floor(d) + 'km'
    }
  },
  mounted() {
    this.reloadFunc()
  }
})
